export const initValues = {
  parent: {
    name: '',
    email: '',
    language: ''
  },
  friend: {
    name: '',
    email: '',
    content: ''
  }
}

export const initErrors = {
  parent: {
    name: '',
    email: '',
  },
  friend: {
    name: '',
    email: '',
  }
}

export const initComponentErrors = {
  parent: {
    email: ''
  },
  friend: {
    email: ''
  }
}